import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import CreateForm from "./CreateForm";
import createItemAPI from "@services/Clients/Reisinger/nftPieces/createAsset";
import validator from "@validators/Clients/Reisinger/nftPieces/NftAdd.validate";
import formMapper from "@mappers/Clients/Reisinger/nftPieces/CreateAsset.mapper";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
